import { render } from "./AddSvgIcon.vue?vue&type=template&id=69ab0e4a"
import script from "./AddSvgIcon.vue?vue&type=script&lang=js"
export * from "./AddSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__